module.exports = __webpack_public_path__ + "static/media/27-2.cbf0b19c.mp3";